'use strict';
import React from 'react';
import {buildFormHOC} from '../../../components/forms/Form';
import {INPUT_TYPES} from '../../../components/forms/FormField';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {canEditChildProp} from '../../domain/utils';
import {TaskFormView} from './TaskFormView';


export const TaskFormComponent = buildFormHOC(TaskFormView, {
  fields: [{
    property: 'name',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: canEditChildProp,
    useError: true,
  }, {
    property: 'isPrivate',
    type: INPUT_TYPES.checkbox,
    constraints: {},
    canEdit: model => !getId(model) && canEditChildProp(model),
    useError: true,
  }, {
    property: 'description',
    type: INPUT_TYPES.text_long,
    constraints: {nullable: true},
    canEdit: true,
    useError: true,
  }, {
    property: 'milestone',
    type: INPUT_TYPES.select,
    canEdit: canEditChildProp,
    useError: false,
  }],
});



// WEBPACK FOOTER //
// ./src/js/tasks/components/TaskForm/TaskFormComponent.js